;
define("cart_item_summary.tpl", function(){});

